// 中文简体多語言
const zh = {
    _code: "编码",
    _name: "名称",
    _cost: "成本",
    _member: "会员",
    _vendor: "供应商",
    _inventory: "库存",
    _discount: "折扣",
    _user: "使用者",
    _shop_and_station: "分店/工作站",
    _base_setup: "基本设定",
    _wechat_report_manager: "微信客户报表管理",
    _wechat_report_auth: "微信报表授权管理",
    _user_maintenance: "使用者维护",
    _search: "搜索",
    _reset: "重置",
    _edit: "修改",
    _askdelete: "是否删除资料 ?",
    _delete_ok: "删除成功",
    _exit: "退出",
    _save: "保存",
    _delete_fail: "删除数据失败",
    _connect_hq_failed: "连接HQ失败",
    _not_allow_empty: "不允许为空",
    _connecting: "正在连接服务器，请稍候...",
    _plesase_wait: "请稍候",
    _login: "登录",
    _password: "密码",
    _user_name: "用户名",
    _login_password_error: "密码错误",
    _connect_database_failed: "连接数据库失败",
    _select_please: "请选择",
    _void_by: "取消者",
    _edit_by: "修改者",
    _create_by: "建立者",
    _void_date: "取消日",
    _edit_date: "修改日",
    _create_date: "建立日",
    _role_list: "角色列表",
    _recall: "恢复",
    _back: "返回",
    _super_admin: "超级管理员",
    _errtitle: "系统错误",
    _btn_close: "关闭",
    _err_code: "错误代码",
    _err_message: "错误信息",
    _err_prog: "错误程序",
    _cfm_title: "确认提示框",
    _cfm_msg: "是否要继续",
    _cfm_btnyes: "确定",
    _yes_msg: "操作成功！",
    _err_prog_msg: "程序发生错误，请与供应商联系",
    _dele: "删除",
    _role: "角色",
    _current_user: "当前使用者",
    _success: "成功",
    _failure: "失败",
    _home_page: "首页",
    _navigation_menu: "导航菜单",
    _lbl_lock: "锁定栏",
    _chk_show_deleted: "显示已删除资料",
    _username: "使用者名称",
    _user_password: "使用者登入密码",
    _show_all_menu: "显示所有菜单",
    _show_authorized_menu: "仅显示有权限的菜单",
    _reprot_menu_option: "报表菜单选项",
    _search_other_shop: "查询其它分店",
    _confirm_cardno: "确认磁卡密码",
    _comfirm_password: "确认使用者密码",
    _full_name: "用户全名",
    _user_role: "使用者角色",
    _language: "使用语言",
    _max_discount_rate: "最高折扣率",
    _salesman: "营业员",
    _cardno: "磁卡编码",
    _auto_exit: "完成后自动退出",
    _hq: "HQ",
    _fore_sales: "前台銷售",
    _report_center: "报表中心",
    _shop: "分店",
    _askrecall: "是否恢复资料？",
    _recall_success: "恢复成功",
    _suspend: "暂停使用",
    _addr: "地址",
    _district: "地区",
    _country: "国家",
    _shopgroup: "分店组群",
    _tel: "电话",
    _fax: "传真",
    _contactperson: "联络人",
    _switch_tn: "可替其他分店开[转仓单]",
    _switch_ii: "可替其他分店开[购货单]",
    _switch_ord: "可替其他分店开[订货]",
    _switch_adj: "可更改其他分店库存数量",
    _switch_sto: "可替其他分店做盘点",
    _instant_sales: "即时营业额",
    _dummy_shop: "假分店",
    _delivery_time: "发货时间",
    _monday: "星期一",
    _tuesday: "星期二",
    _thursday: "星期四",
    _friday: "星期五",
    _saturday: "星期六",
    _sunday: "星期日",
    _holiday: "公众假期",
    _wednesday: "星期三",
    _allow: "允许",
    _execute: "执行",
    _export: "汇出",
    _import: "汇入",
    _print: "打印",
    _email: "电邮",
    _commit: "审核",
    _edit_not_allow: "不能修改已删除资料",
    _operating_time: "操作时间",
    _operating_type: "操作类型",
    _old_data: "旧数据",
    _new_data: "新数据",
    _field_name: "字段名称",
    _loading_old_data: "加载旧数据",
    _role_access: "角色权限",
    _view: "查看",
    _content: "内容",
    _fr_inv: "新增发票",
    _view_historical_records: "查看历史记录",
    _exit_system: "退出系统",
    _do_not_input_same_code: "不能输入重复的编码",
    _role_no_access: "该用户无此权限!",
    _verify_password_err: "密码/卡号错误!",
    _access_validate: "权限验证",
    _access_authorize: "授?",
    _yes: "是",
    _no: "否",
    _not_found: "找不到资料",
    _user_type: "使用者类型",
    _copy: "复制",
    _role_copy: "角色复制",
    _to: "至",
    _limit: "限制",
    _check_role: "以下角色输入有误，请检查！",
    _win_title: "保雅电脑-Rms8",
    _template: "样板",
    _ip_limit: "IP限制,你不能在此台电脑登入系统.",
    _qty: "数量",
    _repeat: "重复",
    _format_error: "格式错误",
    _select_all: "全选",
    _add_tips: "点击添加新的标签页",
    _user_info: "使用者信息",
    _login_count: "登入次数",
    _pre_login_time: "上次登入时间",
    _pre_lout_time: "上次登出时间",
    _login_info: "登入信息",
    _user_detail_info: "使用者详细信息",
    _change_pwd: "修改密码",
    _delete_not_allow: "删除被拒绝",
    _dl_plugin: "点击下载插件",
    _role_delete: "删除失败，该角色下包含有用户",
    _old_pwd: "旧密码",
    _new_pwd: "新密码",
    _confirm_new_pwd: "确认新密码",
    _login_time: "登入时间",
    _sys_setup: "系统设置",
    __coupen_need_open: "礼券 需要独立支付的按钮",
    _coupen_need_open: "礼券 需要独立支付的按钮",
    _station_function: "工作站功能",
    _station_hardware: "工作站硬件",
    _userinfo: "会员资料",
    _station: "工作站",
    _mac_address: "MAC地址",
    _report_xr_cross: "用户列表",
    _uom: "量度单位",
    _station_name: "工作站名称",
    _unit: "单位",
    _per: "每",
    _save_success: "保存成功！",
    _business_section: "营业时段",
    _section: "时段",
    _rollback: "还原",
    _shop_list: "分店列表",
    _no_of_period: "时段数量",
    _cancel: "取消",
    _has_save_setting: "已成功存储设置",
    _save_system_seting_failed: "设置项保存失败",
    _has_copy: "已复制",
    _copy_success: "复制成功",
    _copy_Failed: "复制失败",
    _percentage: "百分比",
    _lookup: "一般设置",
    _pk_not_found: "没有找到主键",
    _operation: "操作",
    _normal_credit_card: "普通信用卡",
    _cup: "银联",
    _quick_pass_macau: "快速支付(澳门)",
    _vendor_maintenance: "供应商维护",
    _payway: "付款方式",
    _d_add: "送货地址",
    _salute: "称呼",
    _effective_section: "生效营业时段",
    _chk_using: "是否使用",
    _using: "使用中",
    _mustinput: "必填",
    _start_time: "开始时间",
    _end_time: "结束时间",
    _include_shop: "包括分店",
    _exclude_shop: "不包括分店",
    _payway_type: "付款方式类型",
    _ecr: "附加费",
    _pay_days: "付款期限",
    _cur_sign: "货币单位",
    _open_drawer: "打开钱箱",
    _no_decimal_places: "没有小数位",
    _input_cardno: "输入卡号",
    _additional_fee_type: "附加费类型",
    _additional_fee_rate: "附加费率",
    _sales_type: "销售类型",
    _traditional: "繁体",
    _simplified: "简体",
    _item_cn: "中文点菜",
    _item_en: "英文点菜",
    _inv_cn: "简体中文发票",
    _inv_en: "英文发票",
    _sitem: "套餐",
    _recipe: "材料",
    _item_pole_display: "顾客显示屏",
    _new_item_as: "新增货品作为",
    _kitchen_order: "厨房单",
    _days: "月结日",
    _currency_rate: "货币率",
    _ecr_id: "ECR刷卡机",
    _ecr_detail_sub_id: "ECR付款方式",
    _catery: "种类",
    _subcate: "子类",
    _brand: "品牌",
    _outlet_color: "营业区域颜色",
    _pplcnt: "餐厅预设人数",
    _tax: "税项",
    _askppl: "是否需要问人数",
    _auto_disc: "是否允许自动折扣",
    _level_disc_add: "优惠组合加价",
    _no_using: "不使用",
    _custom: "自定义",
    _order: "点菜",
    _chinese: "中文",
    _english: "英文",
    _print_maintenance: "印表机维护",
    _dishes_cate: "菜式种类",
    _exit_to_system: "确定退出吗 ?",
    _printer_name: "印表机名称",
    _printer_backup: "后备打印机",
    _printer_group: "同组打印机",
    _ask_exit_system: "是否确定退出系统",
    _printer: "印表机",
    _to_printer_name: "转向印机表",
    _print_mode: "菜式打印模式",
    _split: "分拆数量",
    _outlet: "营业区域",
    _diff_print: "请选择不同的印表机",
    item_is_using_not_delete: "货品正在使用,不能删除",
    _each_dish_type: "每款菜式一张",
    _each_piece_of_food: "每件菜式一张",
    _type: "类型",
    _clear_one: "清除一个",
    _clear_all: "清除所有",
    _menu_dishe_cate: "餐牌菜式种类",
    _show_history_holiday: "显示歷史公众假期",
    _holiday_to: "公众假期 由",
    _next_step: "下一步",
    _year: "年",
    _back_step: "上一步",
    _album_maintenance: "相册维护",
    _album: "相册",
    _current_position: "当前位置",
    _replace: "替换",
    _upload_success: " 上传成功",
    _list: "列表",
    _image: "图片",
    _system: "系统",
    _upload_fail: "上传失败",
    _will_also_delete_the_pictures_in_the_album: "将会同时删除该相册中的图片",
    _exist_continue: "已经存在,是否继续",
    _item_transfer: "转仓",
    _date_from: "日期 由",
    _date_to: "日期 至",
    _shop_from: "分店 由",
    _shop_to: "分店 至",
    _doc_adj: "更改存货数量",
    _transfer_note: "转仓单",
    _from_shop: "由分店",
    _to_shop: "至分店",
    _date: "日期",
    _reason: "原因",
    _committed_date: "审核日期",
    _item_code: "货品编号",
    _item_name: "货品名称",
    _amount: "金额",
    _exist_qty: "现有数量",
    _copy_and_new: "复制和新建",
    _belong_date: "所属日期",
    _warning: "警告",
    _dishes_setup: "菜式设定",
    _dishes: "菜式",
    _item: "货品",
    _file_code: "文件编号",
    _item_not_found: "找不到货品",
    _start_time_cost: "开始时成本",
    _the_net_cost: "最后入账成本",
    _final_entry_cost: "最后入货成本",
    _by_min: "按最小",
    _lowest: "最低",
    _order_qty: "定货数量",
    _total: "合计",
    _already_exists: "已存在",
    _not_enough: "不足",
    _item_transfer_reason: "转仓原因",
    _doc_adj_reason: "更改存货数量原因",
    _network_error: "网络错误",
    _please_contact_administrator: "请联系管理员",
    _detailed_information: "详细信息",
    _price: "价格",
    _only_for_following_login: "仅限以下{0}登入",
    _please_input: "請輸入",
    _purchase_order: "购货单",
    _time_manage: "时间管理",
    _active: "生效",
    _daily: "每日",
    _weekly: "每周",
    _monthly: "每月",
    _reverse_selection: "反选",
    _value: "值",
    _effective_date: "生效日期",
    _expiring_date: "到期日期",
    _time: "时间",
    _advanced_setting: "高级设定",
    _expand: "展开",
    _collapse: "折叠",
    _all: "全部",
    _special: "特别",
    _adaptation: "适配",
    _group: "组群",
    _total_amount: "总金额",
    _shop_code: "店铺编号",
    _vendor_code: "供应商编号",
    _vendor_name: "供应商名称",
    _join: "加入",
    _current: "当前",
    _new: "新增",
    _add: "添加",
    _multi_select_dishes: "多选菜式",
    _other_options: "其他选项",
    _copy_to_another_name: "复制到其他名称",
    _link_ppl: "和人数关联",
    _show_in_order: "点菜时显示",
    _multi_choise: "多选",
    _show_in_report: "于报表中分析",
    _multi_qty: "是否乘以数量",
    _cust_modi: "自定特别处理",
    _top_dispord: "点菜时显示于顶层",
    _ppl: "人数",
    _special_price: "特别处理改价金额",
    _special_percentage: "特别处理改价百分比",
    _ordinary_special_treatment: "普通特别处理",
    _ask_for_special_treatment: "问动作特别处理",
    _desc_kit: "其他语言",
    _modi_cate: "种类中的特别处理",
    _Ingredients_increase: "配料处理加价",
    _sort: "排序",
    _modifier: "特别处理",
    _dishes_level: "菜式级别",
    _disc_cate: "折扣种类",
    _color: "顏色",
    _min_amt: "消费金额满",
    _duty_free: "免税项",
    _effective_time: "有效时间",
    _time_type: "时间类型",
    _ascending: "升序",
    _descending: "降序",
    _disc_dishes_level: "有效菜色级别",
    _disc_sys_user: "生效用户",
    _level_combination: "级别 (A) + 级别 (B) --> 菜式级别 (B) 价格",
    _item_level_rule: "菜式级别规则",
    _a_item_level_id: "菜式级别 (A)",
    _b_item_level_id: "菜式级别 (B)",
    _rule_type: "规则类型",
    _a_and_b: "在A和B同时在生效时间内点餐适用",
    _a_or_b: "A或B 其中一个在生效时间内点餐适用",
    _suspended: "停用",
    _must: "必须",
    _general: "一般设定",
    _to_the_top: "至顶",
    _to_the_bottom: "至底",
    _callup: "叫起",
    _keyboard: "键盘",
    _remin: "追单",
    _print_inv: "打印发票",
    _table_no: "台号",
    _invitem: "项目",
    _outstanding: "尚欠",
    _credit_card_no: "信用卡号码",
    _sub_total: "小计",
    _rounding: "微调",
    _table_new: "新台",
    _message: "信息",
    _line: "附加线",
    _generate_combo_package: "生成組合套餐",
    _xdisc: "組合优惠",
    _points_redemption: "会员积分换购",
    _sell_perqty: "可售卖数量",
    _modifier_soldout: "特别处理售罄",
    _delay_print: "延时列印",
    _enter: "进仓",
    _Warehouse: "出仓",
    _select_more: "选择多个",
    _discount_list: "项目折扣列表",
    _history: "项目折扣列表",
    _today: "今天",
    _three_days_a: "前三天",
    _three_days_later: "后三天",
    _change_ppl: "更改人数",
    _member_disc: "会员折扣",
    _takeout_pickup: "外卖自取",
    _lock_and_unlock: "锁定解锁",
    _instant_cuisine: "即时菜式",
    _new_temp_table: "新增临时餐台",
    _view_carte: "查看已点菜式",
    _remove_temp_table: "删除临时台",
    _associate_table: "关联餐台",
    _travel_amt: "营业额",
    _book_table: "餐台预订",
    _sales_amount: "营业资料",
    _dishes_order_color: "菜式顏色及次序",
    _display_mode: "切换展示模式",
    _formmodicolor: "特别处理展示次序及颜色",
    _check_turn_table: "产看转台情况",
    _service_charge_setup: "服务费设定",
    _print_eng_dish_paper: "打印英文上菜纸",
    _coupon: "优惠券",
    _modifier_setup: "特别处理设定",
    _seafood_brand: "海鲜牌",
    _check_warehoused: "项目进仓查询",
    _dishes_inventory: "彩色与库存",
    _prepare_checkout: "准备结账",
    _relogin: "重新登录",
    _main_window: "进入主页",
    _area: "区域",
    _sub_area: "分区",
    _save_message: "存储信息",
    _show_all: "显示所有",
    _are_you_sure: "您确定要存储吗？",
    _delete_area: "是否删除区域及相关数据",
    _delete_sub_area: "是否删除分区及相关数据",
    _printer_no: "打印机编码",
    _printer_node: "打印机节点",
    _default_printer_id: "默认打印机编号",
    _file_type: "文件类型",
    _status: "状态",
    _print_date: "打印时间",
    _threed_run: "线程是否运行",
    _TRACE_NOT_FOUND: "交易未找到",
    _setting_new_table_button: "结账是否显示新台按钮",
    _trace_fail: "交易失败",
    _wait_trace: "等待交易",
    _transaction_completion: "交易完成",
    _terminal_busy: "终端繁忙",
    _local_currency: "本地货币符号",
    _setting_order: "点菜设定",
    _setting_oncall_ask_qty: "即起是否问数量",
    _or: "或",
    _reverse: "相反选择",
    _show_checked_only: "只显示已选择项目",
    _available_modifier_list: "可选择的特别处理列表",
    _selected_modifier_list: "已选择的特别处理列表",
    _use_range: "使用范围",
    _min_currency_unit: "最小货币单位",
    _more: "更多",
    _sale: "销售",
    _purchase: "购货",
    _payway_detail: "付款信息",
    _department: "部门",
    _background: "背景",
    _table: "台面",
    _restaurant: "餐厅",
    _printer_setup: "打印设定",
    _order_outlet: "落单营业区域",
    _change_printer_area: "落单区域列印转向设定",
    _can_not_repeat: "不可以重复",
    _are_you_sure_to_delete: "你要删除该{0}吗 ?",
    _rule: "规则",
    _dishes_modifier: "菜式处理",
    _check_time: "检查次数",
    _select: "选择",
    _department_breakdown: "部门分帐",
    _function: "功能表",
    _split_table: "分台",
    _pay: "结账",
    _change_table: "转台",
    _order_slip: "上菜单",
    _split_order: "分单",
    _take_away: "外卖",
    _menu: "餐牌",
    _one: "选一个",
    _change: "找回",
    _missing: "补单",
    _send_order: "送单",
    _invoice: "发票",
    _period_all: "所有菜式一张",
    _sold_out_message: "售罄項目",
    _show_void_item: "查看删除菜单",
    _item_discount: "项目折扣",
    _cancel_group_discount: "取消时段組合套餐",
    _svr_charge: "服务费",
    _printer_forward_setup: "打印机转向设定",
    _srv_free: "免服务费",
    _input_soldout_msg: "输入售罄信息",
    _change_dept_price: "更改部门分账",
    _discount_entire_receipt: "整单折扣",
    _invoiceno: "发票编码",
    _tips: "小费",
    _invoice_amt: "应付",
    _itemno: "编号",
    _item_desc: "菜式名称",
    _order_time: "点菜时间",
    _wait_time: "等待时间",
    _waiter: "服务员",
    _callqty: "即起数量",
    _are_you_sure_changetable: "你确定要转台吗？",
    _last_setting_name: "最新设置",
    _allow_to: "是否允许{0}",
    _handwriting_item: "手写项目",
    _required_item: "必须项目",
    _check_when_receipt_printed: "于印单时检查",
    _times_no_of_guests: "是否乘人数(如茶资)",
    _ask_qty: "须询问数量",
    _ask_price: "须询问价格",
    _default_hold: "预设等叫起",
    _apply_dayend_analysis: "日结时分析",
    _include_in_min_charge: "是否计入最低消费",
    _custom_item: "自选项目",
    _keep_name: "保留名称",
    _no_print_invoice_when_zero: "零金额不允许印发票",
    _can_do: "许可",
    _select_print_area: "选择列印区域",
    _correct: "更正",
    _blank_key: "空白键",
    _upper: "大写",
    _lower: "小写",
    _dishes_print_is_refused: "以下才是金额为零不允许打印",
    _is_defa: "会员预设类型",
    _price_lv: "会员价钱级别",
    _allow_all_pb: "所有价目表",
    _allow_all_mm: "所有优惠组合",
    _birth_add_points: "生日送积分",
    _amt_ceiling: "金额上限",
    _perc: "正价货折扣",
    _perc_disc_item: "特价货折扣",
    _member_type: "会员类型",
    _cannot_change_empty_table: "尚未入座,不能转台",
    _duplicate_disCount: "已存在相同的折扣,是否继续？",
    _expiry_time: "失效",
    _item_cannot_discounted: "该项目不允许折扣！",
    _cln_type: "清机类型",
    _by_station: "按站点",
    _by_user: "按用戶",
    _receipt_printer: "印单列印机",
    _exception: "例外",
    _select_void_reason: "请选择取消原因",
    _are_you_sure_delete: "你要删除选择的菜式？",
    _remain_qty: "剩馀数量",
    _qty_per_section: "每更可售卖数量",
    _warning_qty: "警告库存数量",
    _is_limit_sell: "是否限量售卖",
    _calculate_by_kilo: "按斤计算",
    _calculate_by_hectogram: "按百克计算",
    _total_item_net_amount: "项目折实金额",
    _netamt: "实收金额",
    _no_record_will_be_save: "没有资料是不能储存的",
    _octopus_put_card: "请拍八达通",
    _octopus_rw_100021: "此八达通卡或货品已失效，请联络钢铁客服中心",
    _octopus_rw_100022_l1: "+++ 请勿取消交易 +++",
    _octopus_file_gen: "建立八达通档案成功 !!",
    _octopus_init_100001: "未能接驳八达通收费器",
    _octopus_init_100005: "未能接驳八达通收费器",
    _octopus_init_100101: "Failed to create AR(Save Log)",
    _octopus_init_100102: "Failed to create UD(Save Log)",
    _octopus_init_100099: "Firmware upgrade has performed due to HouseKeeping()",
    _octopus_rw_100001: "未能接驳八达通收费器",
    _octopus_rw_100005: "未能接驳八达通收费器",
    _octopus_rw_100016: "读卡错误, 请重试",
    _octopus_rw_poll_100017: "读卡错误, 请重试",
    _octopus_rw_deduct_100017: "读卡错误, 请重试",
    _octopus_rw_100017: "读卡错误, 请重试",
    _octopus_rw_100034: "读卡错误, 请重试",
    _octopus_rw_100020: "请再拍卡",
    _octopus_rw_100022: "交易未完成, 请重试",
    _octopus_rw_100023: "Transaction Log full",
    _octopus_rw_100032: "请再拍卡",
    _octopus_rw_100048: "余额不足",
    _octopus_rw_100049: "储值额超出上限",
    _octopus_error: "发生错误(编号",
    _octopus_starting_please_wait: "八达通处理器正在启动中, 请稍候 ... ... ...",
    _octopus_init_again_please_wait: "检查八达通处理器, 请稍候 ... ... ...",
    _octopus_rw_100057: "零售限额已过",
    _octopus_rw_100025: "交易未完成, 请重试",
    _octopus_rw_100022_retry: "请重试(八达通号码",
    _octopus_can_not_use_select_other_payment: "不能使用八达通, 请选用其他付款方法",
    _octopus_rw_same_card_retry: "错卡, 请重试 ( 八达通卡编号",
    _octopus_re_connct_are_you_sure: "是否 重新检查八达通处理器 ?",
    _octopus_it_may_take_1_or_2_minute: "可能需时 1- 2 分钟",
    _octopus_card_adult: "成人",
    _octopus_card_student: "学生",
    _octopus_card_child: "小童",
    _octopus_card_elder: "长者",
    _octopus_card_personalized: "个人",
    _octopus_rw_100019: "此卡失效",
    _octopus_add_value_exceed_limited: "储值额超出上限",
    _octopus_deduction_value_exceed_limited: "扣除金额超出上限",
    _octopus_rw_100024: "此卡失效",
    _octopus_rw_100051: "控制台识别码不正确",
    _octopus_add_value_can_not_void: "八达通增值, 不能刪除此此票",
    _octopus_add_value_can_not_edit: "八达通增值, 不能更改此此票",
    _octopus_change_to_cash: "刪除时会转成 [ 现金 ]",
    _octopus_print_remain: "余额",
    _octopus_print_cardno: "八达通卡号码",
    _octopus_print_device: "机号",
    _octopus_print_payment: "八达通付款",
    _octopus_rw_100022_l2: "交易未能完成请通知顾客用同一张卡",
    _octopus_rw_100022_l3: "再次拍卡，以确保交易无误",
    _time_comparison: "结束时间必须大于开始时间",
    _diff_time: "时间重叠",
    _not_found_file: "找不到档案 !!",
    _database_name: "数据库名称",
    _cover: "位",
    _include_all_shop: "(* = 包括所有分店 )",
    _exclude_all_shop: "(* = 不包括所有分店 )",
    _price_level: "价钱级别",
    _level: "级别",
    _kit_order_print_ppl: "厨房单是否印列人数",
    _kit_print_item_amount: "厨房单是否印列金额",
    _kitchen_order_slip_content: "厨房单列印內容",
    _kit_print_order: "厨房单打印次序",
    _kit_modi_print_langue: "特别处理列印内容",
    _notify_kit_when_void_item: "取消菜式是否通知厨房",
    _notify_kit_when_move_table: "转台是否通知厨房",
    _print_to_kitchen: "是否打印厨房单",
    _kit_print_item_code: "厨房单是否列印菜式编号",
    _void_item_all_in_one: "取消菜式是否所有菜式一张单",
    _table_move_print_item: "整单转台是否列印菜式内容",
    _sitem_print_add_line: "套餐是否列印间线",
    _password_expiration_days: "密码过期天数",
    _can_not_same_as_recent_use: "不能与您最近使用的相同",
    _expired: "过期",
    _password_rules: "密码规则",
    _whether_freeze_password: "是否冻结密码",
    _freezing_minutes: "冻结分锺",
    _please_change_password: "请尽快修改密码",
    _already_frozen_log_after: "已冻结,请{0}分钟后再登录",
    _cash_pay: "现金付款",
    _retry: "重试",
    _unselect_all: "全不选",
    _sell: "售卖",
    _octopus_com_port: "八达通连接埠",
    _setting_kit: "厨房单打印设定",
    _octopus_have_display: "八达通装置有显示银码",
    _octopus_baud_rate: "八达通连接速度",
    _octopus: "八达通",
    _setting_table_setup: "堂座模式",
    _table_flash_having_unfinish: "有未完成项目时餐台是否闪动",
    _table_can_chg_diff_outlet: "不同区域是否允许转台",
    _direct_pay_mode: "是否直接付款",
    _octopus_loc_id: "八达通Location ID",
    _void_item_ask_reason: "取消菜式是否问原因",
    _change_price_after_printed: "已印至厨房是否允许更改价格",
    _can_sell_sellout_item: "售罄后是否允许继续售卖",
    _click_item_red_flash: "点击时是否使用红色框提示闪动",
    _modi_item_allow_neg: "菜式金额是否允许为负数",
    _crashier_auto_exit: "结账自动退出时间(秒)",
    _crashier_preview_inv: "结账是否预览发票",
    _disc_srv: "服务费是否允许折扣",
    _table_show_big: "餐台放大显示比例",
    _copy_station: "复制站点",
    _input_sequence: "按入单次序",
    _previous_page: "上一页",
    _group_by_item_order_by_amt: "编号加总再按金额排序(由大到小)",
    _next_page: "下一页",
    _group_by_item_order_by_qty: "编号加总再按数量排序(由大到小)",
    _group_by_item_order_by_item: "编号加总再按编号排序(由大到小)",
    _void_reason: "取消原因",
    _entire_system: "整个系统",
    _outlet_mode: "营业区域模式",
    _cln_cash_in_reason: "清机收入原因",
    _cln_cash_out_reason: "清机支出原因",
    _kitchen: "厨房",
    _chinese_englisth: "中文+英文",
    _chinese_english_kitchen: "中文+英文+厨房",
    _other_langue: "其它语言",
    _chinese_other_langue: "中文+其它语言",
    _english_other_langue: "英文+其它语言",
    _kit_other_langue: "厨房+其它语言",
    _chinese_english_other_langue: "中文+英文+其它语言",
    _chinese_kitchen: "中文+厨房",
    _english_kitchen: "英文+厨房",
    _join_print_inv: "加入发票打印",
    _floor_plan_mode: "平面图模式",
    _simple_mode: "简单模式",
    _keyboard_input_qty: "键盘输入时必须输入数量",
    _about: "关于",
    _invoice_print_in_fastfood: "快餐是否印发票",
    _inv_qty_for_fastfood: "快餐发票打印张数",
    _fastfood_askno: "快餐人手输入叫号",
    _fastfood_need_remark: "快餐是否需要输入备注",
    _auto_askno_begin: "自动叫号开始编号",
    _auto_askno_end: "自动叫号结束编号",
    _fastfood_choose_outlet: "快餐模式是否可选择营业区域",
    _fastfood_can_only_save: "快餐模式是否允许补单",
    _fastfood_split_print: "快餐模式是否有分单打印功能",
    _auto_askno_ab: "自动叫号是否选择AB",
    _askno_auto_reset: "自动叫号是否每天RESET",
    _cashier: "收银员",
    _invno: "发票号码",
    _seattime: "入座时间",
    _amtperhead: "人均消费",
    _scriber: "签署",
    _use: "用餐",
    _sit: "入座",
    _printed: "已打印",
    _clear: "清理中",
    _lock: "锁定",
    _table_clearing: "餐台仍在清理中",
    _continue_anyway: "是否继续?",
    _is_require_qty: "是否询问数量",
    _dedu_srv: "是否可对冲服务费",
    _fast_food_mode: "快餐模式",
    _inv_setup: "发票打印设定",
    _setting_email: "电邮设定",
    _pay_slip_setting: "埋脚纸打印设定",
    _paylist_print_ntime: "埋脚纸打印数量",
    _octoups_print_paylist: "八达通付款是否印埋脚纸",
    _print_slip_setting: "上菜纸打印设定",
    _print_slip: "是否打印上菜纸",
    _fastfood_print_slip: "快餐模式是否列印上菜纸",
    _turn_to_page: "转入分页",
    _page: "页面",
    _maintenance: "维护",
    _manage: "管理",
    _tables: "桌面",
    _height: "高度",
    _width: "宽度",
    _foreColor: "前景色",
    _confirm: "确认",
    _upload: "上传",
    _setup: "设置",
    _prompt: "提示",
    _remark: "备注",
    _file_does_not_exist: "文件不存在",
    _over_maximum_gust_amount: "人数超出限制",
    _receipt_printed: "餐台已印单",
    _cannot_change_table: "不能转台",
    _send_reminder: "你是否进行催单？",
    _step: "第{0}步",
    _from: "由",
    _change_table_coanot_be_undone: "转台操作不可恢复",
    _cannot_change_be_diff_outlet: "不同区域,不可转台",
    _printed_cannot_continu: "已印单,不允许再进行此操作！",
    _not_set: "未设定",
    _cateries: "分类",
    _remin_time: "追单时间",
    _paidtime: "结账时间",
    _inv_print_addition_header: "发票是否列印银码纸",
    _print_perhead: "是否打印人均消费",
    _inv_print_itemcode: "发票是否列印菜式编号",
    _max_ppl: "餐台最大人数",
    _inv_remark: "发票备注",
    _not_allow_zero: "输入不能为零",
    _printed_item_notallow_up_qty: "菜式已印单,數量只可改小,不可改大!",
    _cleaning_table_reset_time: "清理中的餐台自动恢复正常时间(分",
    _disc_not_active: "折扣不生效,请检查折扣设定",
    _item_level_disc_disable: "折扣对此菜式的级别无效.",
    _pricebook: "价目表",
    _as_discount: "作为折扣",
    _data_already_exists: "数据已经存在",
    _fix_price_qty: "修改价格和数量",
    _default_item: "预设菜式",
    _have_no_right: "你没有使用权限",
    _please_contact_with_admin: "请联系管理员",
    _askno_ppl: "叫号/人数",
    _askno: "叫号",
    _itemlist: "项目清单",
    _inv_amt: "发票金额",
    _paid_amt: "付款金额",
    _change_price: "转价",
    _payment_slip: "付款清单",
    _dept_analyse: "部门分析",
    _reprint_inv_dntpay: "重印发票,请勿付款 !",
    _slip_printer: "上菜纸打印机",
    _inv_printer: "发票打印机",
    _station_setup: "工作站设置",
    _input_askno: "請輸入叫号",
    _input_remark: "請輸入备注",
    _copy_shop: "复制分店",
    _email_smtp: "SMTP",
    _email_user_password: "用户密码",
    _email_port: "电邮端口",
    _email_method: "发送电邮程序",
    _email_co: "电邮上的寄件者名称",
    _email_format: "附件格式",
    _email_user_name: "用户名称",
    _print_pay_slip: "是否打印埋腳紙",
    _modifier_list: "特別处理列表",
    _is_allow_tips: "是否允许小费",
    _exchange: "对换数",
    _outletsrv: "是否按区域收取服务费",
    _tick_will_be_added_to_dishes_in_menu: "打√, 将会在餐牌下对应的菜式种类中加入当前菜式; 取消√, 将会删除当前菜式在餐牌下对应的菜式种类中的所有价格",
    _all_time: "全部时间",
    _click_delete_will_remove_menu_under_dishes: "点击删除, 将会删除当前餐牌对应菜式种类下的对应菜式",
    _tick_will_add_dishes_cate_in_menu: "打√, 将会在餐牌中加入当前菜式种类, 取消√, 将会在餐牌中删除当前菜式种类; 点击添加菜式, 将会在餐牌下当前菜式种类中加入菜式; 点击删除, 将会删除餐牌下当前菜式种类中的对应菜式.",
    _tick_on_the_appropriate_line: "请在相应行打√",
    _differ_time: "时间差",
    _voidtime: "取消时间",
    _tables_information_management: "桌面信息管理",
    _select_background_image: "选择背景图片",
    _background_image: "背景图片",
    _system_image: "系统图片",
    _custom_image: "自定义图片",
    _upload_imagge: "上传图片",
    _self_order: "自助点餐",
    _please_input_item_code: "請輸入题目编号",
    _search_by_itemno: "搜索编号",
    _set_table: "设置餐桌",
    _undecided_dishes: "未定菜式",
    _please_input_qty: "請輸入数量",
    _no_found: "沒有找到",
    _delete_octopus_tips: "不允许删除八达通",
    _please_select_menu: "请选择餐牌,并按确定按钮",
    _this_table_is_locked: "该桌台正在点餐,无法进入",
    _has_been_sold_out_cannot_order: "已售罄,不可以点餐",
    _has_been_sold_out_can_order: "已售罄,可以点餐",
    _select_target_table: "请选择目标餐桌",
    _send_order_success: "送单成功",
    _tables_can_chg_after_print: "印单后是否允许转台",
    _direct_pay_show_inv: "直接付款是否显示发票",
    _hide_main_table: "分台界面是否隐藏主台(为空时)",
    _sit_overtime: "入座多少分钟后开始提示",
    _sit_deadtime: "入座多少分钟后开始大提示",
    _content_repeat_re_input: "输入内容重复,请重新输入",
    _active_time: "生效时间",
    _re_play: "落单",
    _select_please_color: "请选择颜色",
    _checked_table: "选台",
    _dishes_code: "菜式编码",
    _can_only_choose_one: "只能选择其中一项",
    _custom_color: "自定义颜色",
    _apply_custom_color: "采用自定义颜色",
    _copy_color_to_items_with_same_catery: "把颜色拷贝至同一种类",
    _change_no: "更改人数",
    _insert_blank: "插入空行",
    _remove_blank: "删除空行",
    _effective_section_must_cover_24_hours: "营业时段必须覆盖24小时",
    _all_cash: "全数现金",
    _card_no: "卡号",
    _should_change: "应找回",
    _tables_pplcnt_notallow_zero: "已点菜,人数不能改为零 !",
    _auto_number: "自动编号",
    _all_shop: "全部分店",
    _please_correct_the_pay_amount: "请更正付款金额",
    _please_input_amount: "請輸入金额",
    _please_input_change: "請輸入找回",
    _cannot_further_split_table: "已是子台,不可以再分台",
    _please_input_no: "請輸入人数",
    _please_input_cutom_discount_amount: "請輸入自定义折扣金额",
    _please_input_price_per_unit: "請輸入价格",
    _cannot_increase_qty: "菜式已印单,数量只可改小不可改大",
    _item_show_descen: "菜式项目是否同时显示中英文名称",
    _item_colsint: "菜式显示列间隔",
    _modi_large_gui: "特别处理加大显示界面",
    _item_lines: "菜式项目显示行数",
    _item_cols: "菜式项目显示列数",
    _modi_fontsize: "特别处理字体大小",
    _modi_panel_backcolor: "特别处理界面背景颜色",
    _cate_fontsize: "菜式种类字体大小",
    _cate_panel_backcolor: "菜式种类背景颜色",
    _cate_lines: "菜式种类显示行数",
    _orderlist_backcolor: "点菜界面背景颜色",
    _item_selected_color: "点菜选定颜色",
    _order_lines: "点菜界面行数",
    _modi_lines: "特别处理显示行数",
    _modi_cols: "特别处理显示列数",
    _modi_lineint: "特别处理显示行间隔",
    _modi_colsint: "特别处理显示列间隔",
    _cate_lineint: "菜式种类行间隔",
    _cate_colsint: "菜式种类显示列间隔",
    _order_lineint: "点菜界面行间隔",
    _disp_item_id: "点菜时是否显示菜式编号",
    _cate_cols: "菜式种类显示列数",
    _item_fontsize: "菜式项目字体大小",
    _item_panel_backcolor: "菜色项目背景颜色",
    _order_item_fontsize: "落单菜式字体大小",
    _item_lineint: "菜式显示行列隔",
    _color_setup: "界面設定",
    _modifier_color_setup: "特别处理颜色及次序",
    _brow_level_item: "查看当前级别的菜式",
    _please_select_printer_language: "请选择打印机语言",
    _select_language: "选择语言",
    _select_at_least_one: "至少选一个",
    _please_select_system_language: "请选择系统语言",
    _table_setup: "餐台设置",
    _local_report: "本地报表",
    _dishes_list: "菜式列表",
    _hide: "隐藏",
    _kit: "厨房单",
    _kit_cancel: "厨房取消单",
    _kit_remind: "厨房催单",
    _kit_take_away: "厨房外卖单",
    _kit_change_table: "厨房转台单",
    _inv_dine_in: "发票(堂座)",
    _inv_take_away: "发票(外卖)",
    _pay_slip_dine_in: "埋脚纸(堂座)",
    _addition_header: "银码纸",
    _pay_slip_take_away: "埋脚纸(外卖)",
    _slip: "上菜纸",
    _report_sourece: "报表源",
    _dishes_combo: "菜式组合",
    _cannot_move_table_in_use: "不能移动使用中的台",
    _tableno_not_found: "找不到台号",
    _are_you_suret_remove_this_table: "你确定要删除吗",
    _add_new_page: "添加新页",
    _fastfood_info: "快餐信息",
    _cln_report: "清机报表",
    _paid_analyse: "付款分析",
    _outlet_analyse: "区域分析",
    _item_analyse: "菜式分析",
    _section_analyse: "营业时段分析",
    _printed_item_move: "印单后转台菜式",
    _report_type: "报表类型",
    _invoice_list: "发票清单",
    _cln_no: "清机编号",
    _void_item: "取消菜式",
    _refresh_data: "刷新数据",
    _display_cancel_report: "显示取消报表",
    _modify_invoice: "修改发票",
    _modify_pay_slip: "修改埋脚纸",
    _modify_table_slip: "修改上菜纸",
    _modify_kit: "修改厨房单",
    _modify_addition_header: "修改银码纸",
    _modify_cln_report: "修改清机报表",
    _select_report_file: "选择报表文件",
    _times: "次数",
    _title: "标题",
    _send_email: "发送邮件",
    _email_to: "发送邮件",
    _email_cc: "邮件抄送",
    _no_srv_amt: "不含服务费金额",
    _end: "结束",
    _disc_analyse: "折扣分析",
    _orgamt: "原本金额",
    _expense_amount: "支出金额",
    _cash_amt: "实收现金",
    _inv_qty: "发票张数",
    _cust_qty: "顾客人数",
    _amtperorder: "平均每单消费",
    _discamt: "折扣金额",
    _total_tips: "小帐合计",
    _opening_cash: "银头",
    _spectra: "刷卡机",
    _cash_drawer: "钱箱",
    _cash_drawer_com_port: "钱箱连接埠",
    _cash_drawer_baud_rate: "钱箱连接速度",
    _is_visible: "是否可见",
    _cash_drawer_data_bits: "钱箱连接速度",
    _spectra_com_port: "刷卡机连接埠",
    _yes_no: "是/否",
    _invoice_info: "营业资料",
    _display_order: "显示次序",
    _report_path_not_found: "报表路径未找到",
    _reprint_report: "重印报表",
    _inv_printing: "列印发票细节",
    _dept_printing: "列印部门分析",
    _disc_after_inv: "印单后折扣",
    _sending_mail: "正在发送邮件,请稍等...",
    _inv_prined: "已列印发票",
    _calc_with_org_price: "以原价计",
    _calc_with_act_price: "以实价计",
    _title_length: "标题长度必须大于1",
    _date_range: "日期范围",
    _cln_date: "清机日期",
    _cln_data: "清机数据",
    _closing_include: "清机包括",
    _cash_in: "现金收入",
    _edit_table: "编辑台",
    _remove_table: "删除台",
    _opening_cash_detail: "银头明细",
    _move_table: "移动台",
    _save_setting: "保存设置",
    _page_manage: "页面管理",
    _set_backundimage: "设置背景图片",
    _sales: "销售",
    _report_daily: "日结报表",
    _invalid_date: "日期错误",
    _select_first: "请先选择{0}",
    _edit_report: "修改报表",
    _same_lang: "名称全部与{0}相同",
    _show_cashier: "付款分析时显示收银员(多馀一个小时)",
    _actual_price: "以实计价",
    _show_items_whith_price_zero: "打印当天价格更新记录",
    _disc_after_print_inv: "印单后折扣",
    _hourly_sales_amount: "每小时营业额",
    _the_details_invoice_of_discount: "发票折扣细节",
    _item_set_price: "套餐菜式加价",
    _receipt_price_changed: "打印当天的价格更改记录",
    _showitem_with_zero: "日结分析的菜式金额为零时是否显示",
    _no_disc_points_card: "无折扣有积分会员卡",
    _modify_payment_slip: "修改付款清单",
    _modify_slip: "修改上菜纸",
    _modify_kitchen_order: "修改厨房单",
    _share_order: "分单",
    _call_item: "即起菜式",
    _check_choiced_item: "查看已点菜式",
    _ask_discount_reason: "折扣是否问原因",
    _table_add_cleaning_status: "结账后加入清理状态",
    _disc_reason: "折扣原因",
    _order_ingredient_option: "请选择动作！",
    _select_modifier: "请选择特别处理",
    _table_no_order_nochange: "该餐台未点菜,不允许转台",
    _table_nouse_nochange: "尚未入座,不能转台！",
    _input_qty: "請輸入折扣数量",
    _min_charge: "最低消费差额",
    _invinfo_show_amt: "营业资料是否是显示总金额",
    _do_clean_table_must_empty: "必须清空所有餐檯才能清机",
    _print_itemlist_in_pay_slip: "埋脚纸是否打印菜式",
    _slip_print_adduser_time: "埋脚纸是否列印落单人及时间",
    _paylist_print_table_name: "埋脚纸是否印餐台名称",
    _paylist_print_inv_header: "埋脚纸是否列印发票头备注",
    _pay_slip_print_disc: "埋脚纸是否打印折扣",
    _round_to_dollar: "四捨五入到元",
    _round_to_10cents: "四捨五入到毫",
    _more_to_dollar: "多收至元",
    _less_to_dollar: "少收至元",
    _round_to_cents: "四捨五入到仙",
    _more_to_5cents: "多收至五仙",
    _less_to_5cents: "少收至五仙",
    _more_to_50cents: "多收到五毫",
    _less_to_50cents: "少收到五毫",
    _no_change: "不变",
    _input_call_num: "請輸入即起数量",
    _call_qty_larger_than_qty: "即起数量不能大于原数量",
    _allcall: "全部即起",
    _guests: "人数",
    _itemcode: "菜色编号",
    _cmd_ok: "确定 (\<O)",
    _table_booking: "餐台预订",
    _day_before: "前一天",
    _day_after: "后一天",
    _date_selection: "选择日期",
    _current_date: "当天",
    _skip: "跳动",
    _table_clear: "清空台",
    _table_notfound: "找不到台！",
    _language_select: "选择语言",
    _sys_message: "系统提示",
    _dayend: "日结",
    _clean_reprint: "重印清机单",
    _delete_invoice: "删除发票",
    _reprint: "重印",
    _reset_qty: "重置数量",
    _invalid: "不生效",
    _backgrounf_image: "背景图片",
    _square: "正方形",
    _seat_qty: "座位数量",
    _table_no_of: "餐台数量",
    _per_table: "每台",
    _per_head: "每人",
    _big_table_name: "餐台名称放大显示",
    _cleaned: "已清机",
    _non_cleaned: "未清机",
    _datetype: "日期种类",
    _dayend_include: "日结报表包括",
    _preview: "预览",
    _date_time: "日期时间",
    _octopus_no: "八达通卡号码",
    _last_add_value_by_cash: "上一次于 {0} 现金增值",
    _if_you_have_any_queries_on_transaction: "客户如对上述的八达通交易有任何查询，请保存此存根及致电八达通顾客服务热线 2266 2222。",
    _add_table_by_no: "快速新增台号",
    _inv_void: "以下订单将被删除,要继续吗？",
    _drink_qty: "配饮品数量",
    _level_cannot_same: "级别不能相同",
    _level_rule_error: "级别规则定义错误,不允许有交叉定义",
    _table_have_unfinish_item: "该餐台有未完成的项目,不能印单！",
    _invalid_char: "输入字串含有不正确的符号, 请重新输入",
    _change_price_no_level_disc: "更改价格后,不再有餐饮级别优惠,要继续吗？",
    _select_none: "全部清除",
    _allow_to_sell: "是否允许售卖",
    _dishes_price: "菜式售价",
    _copy_to: "复制到",
    _select_one: "选一个",
    _backspace: "后退键",
    _do_clean_table_must_unused: "必须清空所有餐台才能清机！！",
    _table_printed_nochange: "餐台已印单,不能转台！",
    _linkppl_modi_change_ppl_inside: "有人数关联的特别处理,请在入单界面更改人数。",
    _sts_message: "系统提示",
    _enter_sale_info: "设定售罄信息",
    _input_code_or_plus: "输入彩色编号 或 + 號更改数量",
    _cln: "清机",
    _ok: "确定",
    _waitor: "服务员",
    _void_time: "删除时间",
    _table_notallow_lock: "已经有人入座, 不能锁定！",
    _no_unlock_link_inv_table: "该餐台关联的主餐台已印单，不允许解锁.",
    _soldout_dishes: "售罄菜式",
    _item_split: "菜式分单",
    _share_order_done: "以作分单,如需要修改,请先删除分单！",
    _order_split_not_finish: "分单操作未完成！",
    _table_is_locked: "餐台已锁定，请先解锁。",
    _valid: "生效",
    _waiting_time: "等待时间",
    _nitem_onlysave_not_printed: "个项目只作保存不会列印到厨房,是否继续？",
    _table_noorder_noslip: "该餐台未有点菜,不能印上菜纸！",
    _outlet_info_no_exist: "营业区域信息不存在， 请先维护营业区域",
    _tables_page_not_exist: "餐台分页信息不存在,请先维护分页。",
    _outlet_shop_not_exist: "分店营业区域不存在,终止点餐",
    _task_queue: "个任务排队中",
    _order_func: "订单功能表",
    _table_func: "餐台功能表",
    _can_only_add_one_take_away: "外卖类型只能添加一个",
    _expiration_date_can_not_less_than_effective_date: "到期日期不能小于生效日期",
    _empty_section: "营业时段不能为空",
    _exclude_sitem: "套餐除外",
    _split_package_sub_item: "分拆套餐子项目",
    _sub_table_full: "最多只能分15张子台",
    _delete_take_away_tips: "不允许删除外卖类型",
    _cash_bf: "银头",
    _cash_out: "现金支出",
    _chkdept_printing: "列印部门分析",
    _chkhourly_sales_amount: "每小时营业额",
    _show_all_items: "所有菜式",
    _show_all_dishescate: "所有菜类",
    _receipt: "重印单",
    _other_receipt: "其他语言发票",
    _other_slip: "其他语言上菜纸",
    _copy_and_add: "复制添加",
    _include: "包括",
    _exclude: "不包括",
    _clear_input: "清除",
    _service_charge_multiple: "服务费倍数",
    _current_shop: "当前分店",
    _current_station: "当前工作站",
    _inv_chs: "简体发票",
    _inv_cht: "繁体发票",
    _input: "输入",
    _srv_charge: "服务费",
    _payment_slip_eng: "英文付款清单",
    _payment_slip_cht: "繁体付款清单",
    _payment_slip_chs: "简体付款清单",
    _table_noorder_nopay: "尚未点菜,不允许结账！",
    _cancel_share_order: "取消分单",
    _select_discreason: "请选择折扣原因",
    _disc_amount: "折扣金额",
    _unit_price: "单价",
    _unit_price_and_modi_amount: "单价+特别处理加价",
    _kit_item_amt_showtype: "厨房单列印金额内容",
    _default_printer: "默认印表机",
    _printer_paper_problem: "纸张有问题",
    _out_of_tonner: "碳粉用完了",
    _printer_not_available: "打印机不可用",
    _printer_out_of_memory: "内存出错",
    _printer_paper_jam: "卡纸了",
    _printer_paused: "暂停中",
    _printer_low_on_toner: "碳粉不足够",
    _printer_off_line: "离线状态",
    _printer_error_state: "不明原因",
    _printer_user_intervention: "不明原因",
    _printer_full_output_bin: "超过打印队列数量限制",
    _print_server_no_running: "Print Server 未启动",
    _transfer_from: "转由",
    _not_allow_mult_item_disc: "不允许同时对多个菜式进行项目折扣",
    _buildin_data_no_dele: "系统预设数据,不可删除",
    _printer_out_of_paper: "纸张用完了",
    _printer_open_door: "打印机门未关",
    _inv_print_transfer_from: "发票是否列印转由列印机",
    _pay_slip_print_transfer_from: "埋脚纸是否列印转由列印机",
    _slip_print_transfer_from: "上菜纸是否列印转由列印机",
    _copy_to_another_price_from_price1: "从售价1复制到其他售价",
    _item_print_mode_item_set: "套餐列印一张单",
    _slip_print_mode: "上菜纸列印方式",
    _print_all: "全部重新打印",
    _print_new_only: "只打印新增菜式",
    _print_first_only: "不打印新增菜式",
    _slip_print_Item_amount: "上菜纸是否列印金额",
    _slip_print_Item_code: "上菜纸是否印菜式编号",
    _slip_print_include_modifier: "上菜纸是否打印特别处理",
    _slip_print_adduser: "上菜纸是否印点菜人及时间",
    _slip_print_free_modifier: "上菜纸是否列印不加价的特别处理",
    _sitemsub_notallow_disc: "所选菜式不允许项目折扣 !",
    _call_up: "即起",
    _slip_change: "更改",
    _slip_new: "加单",
    _print_now: "立即打印",
    _order_ingredient_base: "你未选择配料！",
    _divided: "分台",
    _hexadecimal: "十六进制",
    _decimal: "十进制",
    _uom_change_continue_save: "单位有变动,会影响计算方法,继续保存吗",
    _name_length_over_limited: "名称长度超出限制",
    _kit_order_print_code: "厨房单是否列印编号",
    _order_entry_item_font_size: "点菜界面菜式字体大小",
    _order_entry_modifier_font_size: "点菜界面特别处理字体大小",
    _outlet_not_found: "营业区域找不到，请先添加营业区域！",
    _show_table_position_by_setting: "是否按设置显示桌台位置",
    _order_must_item: "以下必须项目仍没有落单",
    _table_is_locked_by: "餐台已被{0}锁定",
    _refresh: "刷新",
    _foreign_currency: "外币",
    _domestic_currency: "本国货币",
    _currency_type: "货币类型",
    _cash: "现金",
    _no_of_inv: "发票数量",
    _details: "详细说明",
    _paidlist: "已结账",
    _only_show_uncleaned: "(只显示未清机金额)",
    _price_add: "售价加价",
    _price_breaks: "售价减价",
    _copy_to_another_price: "复制到其它售价",
    _paid_invoice: "已付款",
    _custom_code_repeat: "自定义编码重复",
    _octopus_query: "八达通查询",
    _item_available: "可使用菜式",
    _item_details: "菜式内容",
    _mincharge_diff: "最低消费差额",
    _minimum_rate_for_service_charge: "最低消费服务费率",
    _choose: "选择",
    _backup_when_clean: "清机时是否强制资料备份",
    _kitchen_order_dishes_language: "厨房单菜式语言",
    _kitchen_order_use_only: "仅厨房单使用",
    _current_order_language: "当前点餐语言",
    _inv_header: "发票头备注",
    _inv_footer: "发票尾备注",
    _proan_inside: "保雅内部使用",
    _android_user_interface_setup: "Android用户界面设置",
    _table_no_ppl: "台号/人数",
    _print_modifiers_additional_charges: "特别处理加价时是否打印",
    _print_free_modifiers: "特别处理不加价时是否打印",
    _inv_print_0_amt_item: "金额为零的项目是否列印",
    _print_set_meal_details: "是否打印套餐细节",
    _print_user_and_time_on_invoice: "发票项目是否打印落单人及时间",
    _payway_rate_tip: "设置在生效日期之后, 当前货币可兑换的现金, 如 cash/美元 = 10/1,即1美元等价于10元现金",
    _current_currency: "当前货币",
    _discper: "折扣百分比(%)",
    _modifier_multiple_qty_whether_effective: "特别处理乘以数量是否生效",
    _is_active: "是否有效",
    _effective: "有效",
    _bottom: "最后一行",
    _next: "下一行",
    _prev: "上一行",
    _top: "第一行",
    _address_setup: "地址设置",
    _address_list: "地址列表",
    _area_code: "区域编码",
    _area_setup: "区域编码设置",
    _subarea_setup: "地址设置",
    _hold: "等叫起",
    _clean_input_tips: "清机是否提示输入提示",
    _paylist_print_itemcode: "埋脚纸是否列印菜式编号",
    _period1: "时段1",
    _period2: "时段2",
    _period3: "时段3",
    _order_by: "排序",
    _opening_section: "营业时段",
    _svc_charge: "服务费",
    _order_only: "点菜",
    _whether_to_continue: "是否继续",
    _deshes_level: "菜式级别",
    _setting_general: "一般设定",
    _print_on_order_list: "是否打印上菜纸",
    _set_background_image: "设置背景图片",
    _please: "选择",
    _selected: "选中",
    _page_information_management: "页面信息管理",
    _page_maintenance: "页面维护",
    _slip_print_mode_void_item: "取消菜式时上菜纸列印方式",
    _complete_all_reprint: "完成后全部重新打印",
    _phase: "期",
    _tower: "座",
    _floor: "楼",
    _room: "室",
    _login_account: "登录帐号",
    _alphanumeric_underline_input_only: "只能输入字母数字下划线",
    _buildin_data_no_edit: "系统预设数据,不可修改",
    _historical_records: "历史记录",
    _shop_qty: "分店数量",
    _sales_analysis: "销售分析",
    _select_addr: "請選擇地址",
    _item_warning_mode: "库存警告方式",
    _not_prompt: "不提示",
    _always_prompt: "永远提示",
    _set_by_item: "按菜式设定",
    _qty_not_enough_continue: "库存数量不足,是否继续售卖？",
    _item_warning_qty: "库存不足是否提示",
    _allow_add_price_for_item_discount: "套餐菜式加价是否允许项目折扣",
    _no_sales_item: "包括没有销售的菜色",
    _catery_dishes: "种类+菜色",
    _dept_dishes: "部门+菜色",
    _waiter_dept: "服务员+部门",
    _group_by: "组合",
    _show_cost: "显示成本",
    _show_daily: "显示每日",
    _invalid_invcode: "输入条码格式不正确,请重新输入！",
    _barcode_wrong: "没有此号码的单据！",
    _order_done: "订单已删除！",
    _order_paid: "訂單已結賬",
    _discount_round: "折扣+微调",
    _profit: "毛利",
    _margin: "毛利率",
    _pages: "页数",
    _belongdate: "所属日期",
    _docno: "文件编号",
    _stock_take_option: "盘点选择",
    _part: "部分",
    _variance: "相差数量",
    _takeqty: "盘点数量",
    _aggregate: "累计",
    _sales_analysis_section: "销售分析-时段",
    _show_amt_type: "显示金额",
    _daily_sales: "每日营业额",
    _show_days_without_data: "显示没有记录的日期",
    _show_rounding: "显示微调",
    _avginv: "每单",
    _department_daily_report: "部门按日统计报表",
    _cost_percentage: "成本百分比",
    _committed_cannot_edit: "不允许修改已审核的文件.",
    _delete_cannot_edit: "不允许修改已删除的文件",
    _sto_belongdate: "盘点日期",
    _onhand: "现有数量",
    _variance_cost: "相差数量成本",
    _cmd_stocktake: "盘点",
    _seq_no: "序号",
    _Atte_Cut_time: "考勤截止时间",
    _attendance_cam: "是否有摄像头",
    _attendance_range_count: "考勤截止时间段",
    _function_introduction: "功能简介",
    _dishes_composition_setting: "菜式成分设定",
    _picture: "图",
    _caption: "说明",
    _please_select_department: "请选择菜式所属部门",
    _signinout: "上下班",
    _period: "时间段",
    _sign_in: "上班签到",
    _sign_out: "下班签到",
    _whether_to_clean_up_qty_every_day: "是否每天清理数量",
    _not_commit_no: "还有盘点单未经审核，编号是：",
    _detail: "详细",
    _display: "显示",
    _summary: "精简",
    _income_analysis: "收入+分析",
    _unclassified: "未分类",
    _item_qty_per_day: "菜色每日数量",
    _best_worst_selling: "最佳/最差销售",
    _rank: "名次",
    _hour: "小时",
    _daily_and_hour: "每日+小时",
    _update_modifier_qty_match_item_qty_changes: "更改数量时特别处理是否相应更改(特别处理乘以数量下不生效)",
    _checkout_time: "结账时间",
    _best: "最佳",
    _worst: "最差",
    _count: "数量",
    _money: "金额",
    _species_group_show: "种类分组显示",
    _show_deleted: "显示已删除资料",
    _copy_from_other_shop: "从其他分店复制",
    _number: "次数",
    _picture_maintenance: "图片维护",
    _subcate_dishes: "子类+菜色",
    _brand_dishes: "品牌+菜色",
    _vendor_dishes: "供应商+菜色",
    _change_item_price: "更改项目单价",
    _inv_no: "发票号码",
    _table_useage_analysis: "餐台使用分析",
    _group_show: "分组显示",
    _by: "按",
    _sign: "上下班",
    _pay_off_line: "离线买单",
    _member_no: "会员编号",
    _member_name: "会员名称",
    _member_tel: "会员电话",
    _point_rule: "积分规则",
    _member_maintenance: "会员维护",
    _table_section_analysis: "餐台时段分析",
    _modifier_report: "特别处理报表",
    _paid_in: "实收",
    _discount_percentage: "折扣百分比",
    _special_discount_percentage: "特价折扣百分比",
    _calc_method: "计算方法",
    _discount_report: "折扣报表",
    _mail_addr: "邮寄地址",
    _eng_name: "英文名称",
    _chi_name: "中文名称",
    _mobile_phone: "手提电话",
    _homepage: "网址",
    _job: "职业",
    _id_no: "身份证号码",
    _birthday: "出生日期",
    _join_shop: "加入店鋪",
    _inv_count: "消费次数",
    _current_points: "现有积分",
    _inv_amount: "消费金额",
    _gender: "性別",
    _residential: "住宅地址",
    _male: "男",
    _female: "女",
    _lbl_yyyymmdd: "(年/月/日)",
    _inv_input_member_show_message_1: "当输入或取消会员",
    _inv_input_member_show_message_2: "系统会重新计算每一项金额",
    _points_to_redeem: "积分兑换",
    _point: "积分",
    _normal_calculation: "正常计算",
    _round_to_2_decimal: "四舍五入到两位小数位",
    _round_to_1_decimal: "四舍五入到一位小数位",
    _round_to_integer: "四舍五入到整数",
    _up_to_integer: "少计至整数",
    _down_to_integer: "多计至整数",
    _date_last: "结束日期",
    _can_edit_price_now: "是否允许转价",
    _redeem_to_integer: "是不是整数换积分",
    _move_item: "项目转台",
    _company_name: "公司名称",
    _show_multi_unit_on_kitchen: "厨房单是否显示多单位",
    _show_multi_unit_on_slip: "上菜纸是否显示多单位",
    _show_quick_payment_qr_code: "是否显示快速付款QR Code",
    _kit_callup: "厨房叫起单",
    _tel_addr: "电话/地址",
    _eng_chi_name: "中/英文名称",
    _code_or_email: "编号或电邮",
    _qty_range: "数量范围",
    _payslip_printer: "埋脚纸打印机",
    _already_add: "己加入",
    _already_success: "己加入成功",
    _recipe_already_exist: "材料已存在,不能重复",
    _onhand_qty: "现有数量",
    _take_qty: "盘点数量",
    _approve: "审核",
    _link_man: "联系人",
    _voided_items: "删除项目",
    _unselect: "不选择",
    _member_list: "会员报表",
    _circle: "圆形",
    _not_to_print: "未打印",
    _register: "注册",
    _registered: "已注册",
    _not_registered: "对不起,您尚未注册系统",
    _sex: "性别",
    _code_name: "编号/名称",
    current_printer_is_already_in_use: "当前印表机已使用中, 是否继续",
    "_member/ member_type": "会员/会员类型",
    _no_printer_found: "沒有安裝打印機",
    _show_each_shop: "显示每间分店",
    _qty_not_enough: "庫存數量不足！",
    _whether_server: "是否服务器",
    _amount_number: "帳號",
    _whether_talking_caller: "是否语音报号",
    _regular_discount_percentage: "正价折扣百分比",
    _waiting: "等待中",
    _period4: "时段4",
    _period5: "时段5",
    _show_multi_unit_on_invoice: "发票是否显示多单位",
    _show_multi_unit_on_pay_slip: "埋脚纸是否显示多单位",
    _item_data: "菜色资料",
    _qty_remain: "库存数量",
    _item_no_range: "项目编号范围",
    _sold_out_dishes: "已售罄菜式",
    _not_show_in_order: "点菜时不显示",
    _do_clean_confirm: "是否确定清机？？",
    _inv_checked: "清机完成！",
    _material_list: "成份列表",
    _vendor_list: "供应商列表",
    _section1: "时段一",
    _section2: "时段二",
    _section3: "时段三",
    _section4: "时段四",
    _section5: "时段五",
    _print_modifier_prices: "特别处理是否打印金额",
    _item_id: "菜式编号",
    _point_used: "使用积分",
    _points_remain: "结余积分",
    _day: "日",
    _month: "月",
    _print_modi_same_line: "特别处理是否列印在同一行",
    _print_item_modi_sale_line: "特别处理是否和菜式打印在同一行",
    _inv_print_void_item: "發票是否列印取消菜式",
    _take_away_address: "外卖地址",
    _set_min_charge: "是否设置最低消费",
    _print_pay_slip_fastfood: "外卖是否打印埋脚纸",
    _sys_user_list: "使用者信息",
    _invoice_print: "堂座是否列印发票",
    _member_group_show: "会员分组统计报表",
    _sitem_print_shell: "套餐是否列印套餐名称",
    _print_all_after_completion: "完成后全部重新打印",
    _soldout_setup: "菜式售罄信息设定",
    _service_charge: "服务费率",
    _inv_print_table_name: "发票是否印餐台名称",
    _more_to_min_currency_unit: "多收至最小货幣单位",
    _less_to_min_currency_unit: "少收至最小货幣单位",
    _round_to_min_currency_unit: "四舍五入至最小货幣单位",
    _computer_name: "电脑名称",
    _income: "收入",
    _analysis: "分析",
    _selected_item: "已选择项目",
    _annual_business_report: "全年營業報表",
    _select_please_: "请选择{0}",
    _show_modi: "显示特别处理",
    _effective_outlet: "有效营业区域",
    _month_total: "本月累计",
    _days_total: "日子累积",
    _average_daily: "每日平均",
    _year_total: "本年累计",
    _year_days_accumulate: "本年日子累积",
    _year_average: "本年累积平均",
    _jan: "一月",
    _feb: "二月",
    _mar: "三月",
    _apr: "四月",
    _may: "五月",
    _jun: "六月",
    _jul: "七月",
    _aug: "八月",
    _sep: "九月",
    _oct: "十月",
    _nov: "十一月",
    _dec: "十二月",
    _no_same_outlet: "不同营业区域,是否继续？",
    _allow_all_price_book: "允许所有价格表",
    _exist_same_addr: "存在相同的地址名字",
    _allow_all_disc_pricebook: "允许价目表折扣",
    _allow_pricebook: "允许价目表折扣",
    _include_station: "包括工作站",
    _member_sales_analysis: "会员消费分析",
    _pet_age: "年龄",
    _pet_type: "宠物种类",
    _one_year_amount: "一年销售额",
    _wrist: "手吋",
    _setup_mode: "设定模式",
    _exclude_holiday: "公眾假期除外",
    _sales_price: "销售价",
    _please_input_name: "請輸入名称",
    _invoice_descending: "单号(由大至小)",
    _invoice_ascending: "单号(由大至小)",
    _tableno_descending: "台号(由大至小)",
    _tableno_ascending: "台号(由小至大)",
    _amount_descending: "金额(由大至小)",
    _amount_ascending: "金额(由小至大)",
    _join_qty_or_spin_off: "点菜合并或分拆处理",
    _not_handling: "不处理",
    _join_qty_when_same_item: "同一菜式合并至一行",
    _mult_order_item_break: "点菜数量大于1分拆",
    _can_not_re_add_to_menu: "不能重复添加在餐牌中",
    _schedule_price: "时段售价",
    _price_fastfood: "外卖售价",
    _sale_period: "只在时段内售卖",
    _calc_with_org_srv: "按原价计服务费",
    _project: "计划",
    _custom_section: "自定义营业时段",
    _tax_setup: "税项设定",
    _remin_reason_setup: "追单原因设定",
    _reason_for_press_alarm: "客户按警钟原因设置",
    _fastfood_message_setup: "外卖信息设定",
    _auto_disc_setup: "自动折扣设定",
    _dine_active: "堂座是否有效",
    _fastfood_active: "快餐是否有效",
    _barcode_active: "条码是否有效",
    _barcode: "条码",
    _barcode_check_out: "条码结帐",
    _order_langue: "点菜界面语言",
    _year_repeat: "每年重复",
    _receipt_remark: "发票备注",
    _charge_type: "馀额处理",
    _change_return: "馀额找回",
    _change_inre: "馀额不找",
    _change_tips: "馀额作小费",
    _currency_ratio: "每单位相当于标淮货币的倍数",
    _is_input_creditcardno: "是否输入信用卡号码",
    _lms_recharge: "會員卡外幣充值",
    _pay_type: "Pax机类型",
    _none: "无",
    _swipe_card: "刷卡",
    _quick_pass: "快速支付",
    _both: "两者皆是",
    _is_cash_coupon: "是否现金券",
    _cash_coupon_value: "现金券面额",
    _bo_cash_coupon_date_startth: "现金券生效日期",
    _cash_coupon_date_last: "现金券终止日期",
    _print_other_lanaguage: "是否指定打印其它语言(如存在)",
    _auto_backup: "负责系统自动备份",
    _linkserver: "连接服务器",
    _default_language: "预设语言",
    _table_page: "预设餐檯页数",
    _allow_signinout: "允许上下班打卡",
    _allow_invoice: "允行结帐",
    _has_drawer: "安装抽屉",
    _port_no: "端口",
    _has_port: "串口抽屜",
    _pole_display: "顾客显示屏",
    _pole_display_message: "顾客显示屏讯息",
    _self_order_tableno: "Android自助落单关联檯号",
    _having_card_reader: "是否有外挂读卡器",
    _queuing_machine: "叫号机",
    _calc_with_tael: "按两计算",
    _kit_print_attention: "注意, 上一张如果打印不完整, 请不要使用",
    _backcolor: "背景颜色",
    _no_check_out_when_zero: "零金额不允许结帐",
    _add_log: "是否添加日志",
    _free_amount_by_order: "每单可奉送金额",
    _auto_order: "自动进入点菜画面",
    _auto_lout: "自动登出系统",
    _auto_lout_return_main: "自动登出时回到主界面",
    _no_operate: "秒没有任何操作,自动登出",
    _info_can_view: "营业资料可检视",
    _password_card_dbl_check: "密码和卡号双重认证",
    _minute: "分钟",
    _no_print: "不列印",
    _no_print_when_zero: "零金额一定不列印",
    _material_cate: "成份种类",
    _menu_manage: "餐牌管理",
    _item_manage: "菜式管理",
    _item_maintenance: "菜式维护",
    _default_disc: "预设折扣",
    _select_classification: "选择类别",
    _advanced_administrator: "高级管理员",
    _fastfood: "外卖",
    _askprice: "即问价",
    _sync_order_dine: "同步到保雅自助落单",
    _please_select_at_least_one_item: "请至少选择一个菜式",
    _please_select_at_least_one_modi_cate: "请至少选择一个特别处理种类",
    _item_modi_batch: "批量操作菜式特别处理",
    _item_modi_batch_update: "批量更新菜式特别处理",
    _item_modi_batch_add: "批量添加菜式特别处理",
    _item_modi_batch_delete: "批量删除菜式特别处理",
    _not_add_if_exist: "存在不新增",
    _only_add: "仅新增",
    _if_exist_the_same_modi_cate_not_add: "如果存在相同特别处理, 则不新增",
    _if_exist_the_same_modi_cate_replace_must_item_and_add_corresponding_quantity: "如果存在相同特别处理, 则替换''是否必须''项, 在原有数量上增加相应数量",
    _item_printer_batch: "批量操作列印设定",
    _item_printer_batch_update: "批量更新列印设定",
    _item_printer_batch_add: "批量添加列印设定",
    _item_printer_batch_delete: "批量删除列印设定",
    _please_select_at_least_one_printer: "请至少选择一个印表机",
    _category: "种类",
    _categories: "分类",
    _item_rule: "菜式规则",
    _original_price: "原价",
    _original_price_fastfood: "外卖原价",
    _copy_color_to_items_with_same_category: "把颜色拷贝至同一种类",
    _if_exist_the_same_modi_cate_replace_must_item: "如果存在相同特别处理, 则替换''是否必须''项",
    _auto_logout: "自动登出系统",
    _auto_logout_return_main: "自动登出时回到主界面",
    _show_password: "显示密码",
    _levelA: "级别A",
    _levelB: "级别B",
    _disc_sys_user_can_not_more_than: "生效用户不能超过{0}个",
    _disc_sys_user_more_than_size: "生效用户超过长度",
    _sure_to_add_all_entry: "确定要加入全部项目吗",
    _not_allow_more_than_char: "不允许超过{0}个字符",
    _current_printer_is_already_in_use: "当前印表机已使用中, 是否继续",
    _item_code_or_barcode_exist_not_repeat: "菜式编号或条码已存在,不允许重复",
    _selforder_item_modi: "自助落单菜式处理",
    _shop_count: "分店数量",
    _can_select: "可选择",
    _term: "项",
    _can_repeat_select: "可重复选择",
    _order_interface_info: "点菜界面简介",
    _item_info: "菜式信息",
    _repeat_not_allow_recall: "重复不允许恢复",
    _cut_order_min: "截单时间",
    _sit_in_min: "总时间",
    _item_cut_order: "截单时间设置",
    _cut_order_min_can_not_longer_than_sit_in_min: "截单时间不能大于总时间",
    _active_section_apply_to_active_dishes_cate: "生效时段应用到生效菜式种类中",
    _not_allow_delete: "不允许删除",
    _upgrade_item: "升级餐菜式",
    _belong_to_item_list: "所属升级餐菜式",
    _not_sync_order: "不同步到保雅自助落单",
    _station_apply_to_active_dishes_cate: "工作站应用到生效菜式种类中",
    _station_apply_to_system_setting: "工作站应用到系统设定中",
    _percent: "百分比(%)",
    _please_set_price_first: "请先设置销售价",
    _so_disc: "自助下单堂座折扣",
    _so_disc_amt: "自助下单堂座折扣金额",
    _so_disc_perc: "自助下单堂座折扣百分比",
    _so_disc1: "自助下单外卖折扣",
    _so_disc_amt1: "自助下单外卖折扣金额",
    _so_disc_perc1: "自助下单外卖折扣百分比",
    _so_print_slip: "自助下单是否打印上菜纸",
    _so_printer: "自助下单上菜纸打印机",
    _total_price_of_all_departments_must_equal_to_price: "各部门相加必须等于售价",
    _whether_add_to_menu: "是否要加入到餐牌？",
    _whether_pop_join_menu_next_time: "下次是否提示加入到餐牌",
    _join_menu: "加入餐牌",
    _multi_item_must_include_an_item: "多选菜式必须包含一个菜式",
    _inventory_management: "存货管理",
    _stock_report: "存货报表",
    _stock: "存货资料",
    _allow_sell: "是否允许售卖",
    _not_allow: "不允许",
    _advanced: "高级",
    _tot_cost: "共成本",
    _compose_type: "组合类型",
    _and: "及",
    _custom_goods: "自定货品",
    _custom_price: "自定售价",
    _custom_fastfood_price: "自定外卖价",
    _copy_to_fastfood_price_from_price: "从销售价复制到外卖售价",
    _upgrade_multi_qty: "升级餐允许多次落单",
    _po_packing_fee_add: "额外餐盒费（外送）",
    _po_plastic_bag_fee_add: "额外料袋费（外送）",
    _pot_packing_fee_add: "额外餐盒费（自取）",
    _pot_plastic_bag_fee_add: "额外料袋费（自取）",
    _po_delivery_fee_add: "额外配送费（外送）",
    _single_po_plastic_bag_fee: "单个料袋收费(外送)",
    _single_pot_plastic_bag_fee: "单个料袋收费(自取)",
    _po_plastic_bag_fee_add_perc: "占单个料袋空间(%)(外送)",
    _pot_plastic_bag_fee_add_perc: "占单个料袋空间(%)(自取)",
    _category_dishes: "种类+菜色",
    _sales_report: "销售报表",
    _brow_level_item_in: "查看菜式级别({0})的菜式",
    _no_ask_remark: "不问备注",
    _must_input_remark: "必须输入备注",
    _ask_remark_can_empty: "问备注,但可允许不输入",
    _whether_ask_remark: "是否问备注",
    _so_qr_order_count: "堂座自助落单每次落单数量上限",
    _so_tables_count_plus_ppl: "堂座总落单数量上限",
    _limit_when_click: "点击时限制",
    _check_when_submit: "提交时检查",
    _total_quantity_may_exceed_the_limit_quantity: "总数量有机会超出限制数量，客户不清楚有数量限制",
    _price_limit_prompt_a_quantity_limit_for_dishes: "严格限制，会明确提示用户菜式有数量限制",
    _extra_pointrate: "额外积分倍数",
    _extra_pointfix: "额外固定积分",
    _points_needed: "所需积分",
    _timing: "计时",
    _is_timer_item: "是否计时菜式",
    _calculated_from_seating_time: "按入座时间开始计算",
    _according_to_adding_dishes_time: "按菜式加入的时间开始计算",
    _how_many_minutes_a_section: "多少分钟一段",
    _timer_level_price: "前{0}个时段价",
    _wechat_pay: "微信支付",
    _alipay: "支付宝",
    _uepay: "极易付钱包",
    _china: "中国",
    _hk: "香港",
    _use_previous_section_price_plus_sell_price_if_zero_for_section_price: "时段价填0，会使用上一时段计算价+售价",
    _price_of_first_X_period_cannot_be_all_zero: "前X时段价不能全为零",
    _add_one: "加一个",
    _minus_one: "减一个",
    _tip: "小费",
    _paymethod: "付款方法",
    _simplify: "精简",
    _daily_turnover: "每日营业额",
    _inv_no_range: "发票编号范围",
    _seat_time: "入座时间",
    _inv: "发票",
    _disc: "折扣",
    _include_srv: "包含服务费",
    _display_modi: "显示特别处理",
    _date_cannot_cross_month: "日期不能跨月份",
    _date_not_found: "对不起！未找到数据",
    _dish_daily_quantity: "菜式每日数量",
    _category_pay_excel: "种类+付款(Excel)",
    _show_each_item: "显示每个菜式",
    _report_date_not_allow_more_than_day: "报表日期不允许超过{0}天",
    _services: "服务",
    _sun: "日",
    _mon: "一",
    _tue: "二",
    _wed: "三",
    _thu: "四",
    _fri: "五",
    _sat: "六",
    _rev_sales_byday: "按日检视销售",
    _Self_help: "自助",
    _Customs: "自定",
    _Custom_Business_Hours: "自定+营业时间",
    _Business_Hours: "营业时间",
    _self_hours_areas: "自助有效营业时段",
    _Only_QrCode_orders: "只适用于QrCode落单",
    _Sales_induction_department: "销售额归纳到部门",
    _default_cup: "茶芥",
    _General_settings: "一般设定",
    _srv_tran: "时段服务费",
    _calc_type: "计算模式",
    _Calculated_dishe: "以加入菜式时间计算",
    _Calculated_seat: "以入座时间计算",
    _srv_name: "转向服务费",
    _start_date: "开始日期",
    _end_date: "结束日期",
    _srv_tran_start_time: "每日起始时间",
    _srv_tran_end_time: "每日终止时间",
    _turn: "转向",
    _srv_tran_empty: "转向服务费不能为空",
    _ex_festival: "节假日除外",
    _srv_tran_sort: "升序或降序至少2行数据",
    _srv_tran_sort_save_tip: "当前选中行数据未保存,请选择其他行再排序",
    _linkserver_backup: "负责落单数据备份",
    _pole_display_silver: "银码显示器",
    _pole_message_silver: "银码显示器信息",
    _unit_swap: "单位对换数",
    _Invoice_cn: "发票(中文名称)",
    _Invoice_en: "发票(英文名称)",
    _Is_it_allow: "是否允许",
    _required_item_check: "必须项目(于印单时检查)",
    _order_interface_info_cn: "中文点菜界面简介(自助点餐)",
    _item_info_self_cn: "中文菜式信息(自助点餐)",
    _order_interface_info_en: "英文点菜界面简介(自助点餐)",
    _item_info_self_en: "英文菜式信息(自助点餐)",
    _ask_dept: "即问分帐",
    _modi_dept_after_inv: "结帐后修改分帐",
    _print_kit: "列印厨房单",
    _total_customer: "总顾客",
    _total_invoice_quantity: "总单数",
    _amount_per_guest: "平均每人",
    _amount_per_order: "平均每单",
    _dine_in_amount: "堂座金额",
    _dine_in_inv_qty: "堂座单数",
    _five_best_selling: "五大好卖",
    _total_sales_amount: "销售总金额",
    _operation_log: "操作日志",
    _already_printed: "已印单",
    _no_printed: "未印单",
    _comparison_report_section: "比较报表-时段",
    _outlet_amount: "营业区域营业额",
    _discount_name: "折扣名称",
    _calc_mode: "计算模式",
    _meal_time: "用餐时间",
    _common_timing: "普通计时",
    _each_time_add: "单项加钟",
    _time_related_ppl: "与人数相关的加钟",
    _display_in_selforder: "保雅自助落单显示",
    _print_order_slip: "列印上菜纸",
    _print_pay_list: "列印付款清单",
    _menu_options: "菜单选项",
    _add_type: "追加方式",
    _unlimit_qty: "不限追加数量",
    _total_qty: "所有子项追加数量",
    _each_item_qty: "每个子项追加数量",
    _add_total_qty: "追加总数量",
    _add_qty: "追加数量",
    _add_qty_upper: "追加上限",
    _include_item: "包含菜式",
    _each_item_qty_not_zero: "每个子项追加数量，数量不能为零",
    _method: "方法",
    _add_qty_upper_zero_info: "追加上限不填写将不限制",
    _disc_mm: "mm",
    _distribute_item: "已分配项目",
    _self_order_remark: "自助落单备注",
    _deleted: "已删除",
    _so_qr_order_count_ppl: "是否乘人数",
    _so_tables_count_plus_ppl_everyone: "堂座自助总落单数量上限(每人)",
    _show_sitem_name: "显示套餐名称",
    _section_price_cate_cannot_empty: "时段售价适用菜式种类不能为空",
    _edit_custom_section_shall_prevail: "全部分店时如果修改了自定义时段后, 以时段为准",
    _sync_foodpanda: "同步到foodpanda",
    _unid_cost: "单位成本",
    _incorrect_shop_price_section: "时段售价设置有误: 全部分店设置在时段内售卖时, 要修改自定义时间",
    _applicable_cate: "适用菜式种类",
    _same_cost_as_dishes: "跟菜式成本",
    _custom_cost: "自定义成本",
    _foodpanda_add_rate: "Foodpanda 加价比率",
    _foodpanda_add_rounding: "Foodpanda 加价零头处理",
    _foodpanda_add_rounding1: "少收至元",
    _foodpanda_add_rounding2: "小收至毫",
    _allow_kb_ord: "点菜键盘搜索时允许",
    _sales_category: "销售种类",
    _must_modi_select_all: "必选特别处理时，全部选择",
    _classification: "类别",
    _channel: "通道",
    _so_tables_count_plus_ppl_active: "乘人数",
    _effective_section_detail: "生效营业时段详情",
    _schedule_price_plan_detail: "时段售价计划详情",
    _schedule_price_shop_detail: "时段售价分店详情",
    _cost_type: "跟菜式成本/自定义成本",
    _void_user: "落单人",
    _net_amt: "付款",
    _void_user_title: "用户",
    _enter_mode: "进入模式",
    _ask_dept_confirm: "启用即问部门分账将不可能对此菜式进行折扣,是否继续?",
    _modi_dept_after_inv_confirm: "启用结账后修改分账将不可能对此菜式进行折扣,是否继续?",
    _operation_record: "操作记录",
    _accident_record: "事故记录",
    _octopus_record: "八达通记录",
    _change_price_record: "更改价格记录",
    _turntable_record: "转台记录",
    _goods_exchange_record: "货品交换记录",
    _worst_selling: "最差销售",
    _best_sales: "最佳销售",
    _worst_selling_amount: "最差销售金额",
    _worst_selling_quantity: "最差销售数量",
    _best_sales_amount: "最佳销售金额",
    _best_sales_quantity: "最佳销售数量",
    _comparison_type: "比较类型",
    _turnover_during_business_hours: "营业时段营业额",
    _wechat_report: "微信报表",
    _departmental_turnover: "部门营业额比例图",
    _qrcode_remind_mins: "自助落单超过多少分钟追单",
    _qrcode_remind_mins_tip: "0代表不追单",
    _shop_tableno_tip: "分店与台号不能为空!",
    _show_in_cup_mode: "在茶芥页面上改数量",
    _focus_item: "重点关注菜式",
    _by_entity_for_calc_qty: "按整条计算数量（报表和售罄）",
    _include_all_cate: "（* =包括所有种类）",
    _festival: "节假日",
    _exclude_festival: "节假日除外",
    _set_sub_item_sold_out: "套餐子项是否计算菜式售罄馀数",
    _dine_in_detail: "堂座详情",
    _order_invoice_list: "发票列表",
    _local_print_kit: "本机列印厨房单",
    _qr_android_local_kit_printer_id: "厨房单打印机(Qrcode, Android本地打印菜式适用)",
    _dine_in: "堂座",
    _restaurant_turnover: "餐台营业额(灾备)",
    _is_itemdept: "是否参与分账",
    _departments_price_can_not_zero: "菜式部门价格不能为零",
    _view_user_password: "查看用户密码",
    _proan_wechat_user: "微信授权关联用户",
    _user_code: "用户标识码",
    _own_role: "所属角色",
    _deleted_user: "原绑定用户已刪除",
    _user_instructions: "用户标识码获取说明",
    _attention_public: "扫码关注微信公众号",
    _click_setting_center: "进入我们的微信公众号,点击【设置中心】",
    _see_personal_information: "进入设置中心页面,即可看到个人信息下方的用户标识码",
    _no_matches_found: "未找到匹配项",
    _only_digits: "只能为{0}位数字",
    _max_effective_users: "最大生效用户数量",
    _number_remaining_users: "剩馀可加用户数量",
    _due_date_wechat_Report: "wechat报表到期日",
    _lookup_shop_list: "包括分店、分店群组、不包括分店至少选择一个",
    _maximum_number_valid_users_exceeded: "已超过最大有效用户数量",
    _calc_time_by: "按当前时间",
    _calc_time_by_current: "按当前时间",
    _calc_time_by_seat: "按入座时间",
    _input_maxlength: "输入长度不能超过{0}个字符",
    _new_start_time: "每天的开始时间",
    _new_end_time: "每天的结束时间",
    _calc_time_by_title: "显示方式",
    _wechat_sys_user_row: "提示：目前显示{0}条用户数据,可使用搜索功能",
    _end_date_to: "日期至",
    _start_date_to: "日期由",
    _date_from_new: "日期由",
    _date_to_new: "日期至",
    _visitor_analysis: "来客分析报告",
    _daily_avg_report: "每日人均报表",
    _add_time: "上传时间",
    _shop_tip: "分店不能为空!",
    _attendance_report: "考勤报表",
    _employee_date: "员工+日期",
    _date_employee: "日期+员工",
    _show_user_id: "显示使用者编号",
    _work_hours: "工作时数",
    _multi_choise_for_proan: "至多选择",
    _must_choise_for_proan: "必选特别处理时生效",
    _min_choise_for_proan: "至少选择",
    _print_limit: "必须选择一个台号,才允许打印",
    _print_all_tip: "当前无打印数据",
    _print_search_tip: "提示:台号非必填项",
    _print_all_report: "全部打印",
    _print_report: "打印",
    _must_select_modi: "必选特别处理时,必选择",
    _case_mat_multiple: "例",
    _case_mat: "席",
    _case_mat_tip: "(为0则不是例/席)",
    _color_desc: "颜色说明",
    _blank_table: "空白台",
    _ever_printed: "曾印单",
    _other: "其他",
    _qr_min_order_qty: "自动点餐菜式最低点菜数量",
    _is_cashier: "收银员",
    _monthly_turnover: "每月营业额",
    _system_name: '公司系统',
    _switch_language: '切换语言成功',
    _theme_switching: "主题切换",
    _full_screen:"全屏",
    _language_label: "语言",
    _account: "账号",
    _login_title: "保雅电脑餐饮后台管理系统",
    _input_code: "請輸入编码",
    _input_name: "請輸入名称",
    _cancel_dekete: "已取消删除",
    _shop_new: "分店[新增]",
    _shop_edit: "分店[修改]",
    _select_please_input: "---请选择---", 
    _saveing: "保存中..",
    _select_please_section:"请选择时段",
    _empty_Tips:"必填信息填写不完整,请检查!",
    _font_size: "字体大小",
    _switch_size: '切换字体大小成功',
    _small: "小",
    _medium: "中",
    _big: "大",
    _input_account: "請輸入账号",
    _input_password: "請輸入密码",
    _logining: "登录中..",   
    _station_new: "工作站[新增]",
    _station_edit: "工作站[修改]",
    _input_station_name: "請輸入工作站名称",
    _select_shop: "请选择分店",
    _back_top: "返回顶部",
    _back_bottom:"返回底部",
};
export default zh;
